import React from "react";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const NavComponent = props => {
  return (
    <Navbar bg="dark" variant="dark">
      <Container style={{
        justifyContent: "center"
      }}>
        <Nav>
          <Nav.Link as={NavLink} to="/">ראשי</Nav.Link>
          <Nav.Link as={NavLink} to="/backlinks">אתרים</Nav.Link>
          <Nav.Link as={NavLink} to="/orders">הזמנות</Nav.Link>
          <Nav.Link as={NavLink} to="/settings">הגדרות</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavComponent;
